/**
 * 插件模块
 *
 * 目前试验阶段，还未正式定型
 */

/* eslint import/prefer-default-export: 0 */
export const plugins = {};
